import getActions from '@admin/utils/get_actions'

const standardActions = getActions([
  { name: 'items', type: 'array' },
  { name: 'test_item', type: 'var' }
])

// Custom drag and drop action
const customActions = {
  onMoveItem: (sourceCode, targetParent, targetIndex = null) => ({
    type: 'MOVE_ITEM',
    sourceCode,
    targetParent,
    targetIndex
  })
}

// Export combined actions object
export default {
  ...standardActions,
  ...customActions
}